import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpProjectExportSiar, HttpProjectExportSiarPayload} from '../http/projects.http'
import {MUTATION_KEYS} from '@/queryClient'
import {FormErrorResponse} from '@/types'
import {AxiosError} from 'axios'

export const useStoreProjectExportSiar = ({
    options
}: {
    options?: UseMutationOptions<Blob, AxiosError<FormErrorResponse>, HttpProjectExportSiarPayload>
}) => {
    return useMutation({
        mutationKey: [MUTATION_KEYS.EXPORT_SIAR],
        mutationFn: payload => httpProjectExportSiar({payload}),
        ...options
    })
}
